import styled,
       { keyframes   } from 'styled-components';

import { themeColors } from 'src/providers/theme/shared';



type LoaderLookAndFeel = {
  background: string; 
  width: number;
  height: number;
  borderRadius: number;
  borderTopColor: string;
  border: string;
  zIndex: number;
}

const loader: LoaderLookAndFeel = {
  background: themeColors.OverlayBackground,
  width: 64, 
  height: 64, 
  borderRadius: 50, 
  borderTopColor: themeColors.PrimaryWhite, 
  border: '6px solid rgba(255, 255, 255, 0.2)',
  zIndex: 9999,
}

export type LoaderVariants = 'loader_main'

export const loader_variants: Map<LoaderVariants, LoaderLookAndFeel> = new Map<LoaderVariants, LoaderLookAndFeel>([
  ['loader_main', loader],
]);

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Overlay = styled.div<{
  lookAndFeel: LoaderLookAndFeel
}>`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(args) => args.lookAndFeel.background};
  z-index: ${(args) => args.lookAndFeel.zIndex};
`;

export const Spinner = styled.div<{
  lookAndFeel: LoaderLookAndFeel
}>`
  width: ${(args) => args.lookAndFeel.width}px;
  height: ${(args) => args.lookAndFeel.height}px;
  border-radius: ${(args) => args.lookAndFeel.borderRadius}%;
  border: ${(args) => args.lookAndFeel.border};
  border-top-color: ${(args) => args.lookAndFeel.borderTopColor};
  animation: ${spin} 1s linear infinite;
`;
